export default __webpack_public_path__ + "static/media/Newsletter 030.80e0a21f.png";